import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Box, Grid, IconButton, Tooltip } from '@material-ui/core';
import PersonalInfoIcon from '../../../assets/img/planner-personalinfo-icon.svg';
import HomeIcon from '@material-ui/icons/Home';
import BasicInformation from '../BasicInformation';
import { isStudent, isAlumni } from '../../../util/miscUtil';

const BasicInfo = ({ alumni, roles, store, auth, handleAfterSaveReturn, setPage, handleReturnToSeniorList, classes, handleGotoAdminHomepage }) => {
  return (
    <summary className={classes.subPageContainer}>
      <div style={{ width: '100%', margin: 0 }} className={classes.pageBanner}>
        <div className={classes.centerForm}>
          <Box
            sx={{
              width: '100%',
              maxWidth: {
                xs: '380px',
                sm: '540px',
                md: '868px',
                lg: '1320px',
                xl: '1320px',
              },
            }}
          >
            <Grid container spacing={0} direction="row" style={{ marginBottom: '60px' }}>
              <Grid item xs={12} align="left">
                <summary className={classes.header} style={{ paddingTop: '30px' }}>
                  <Grid container direction="row" className={classes.subPageHeaderWithIcons}>
                    <Grid item xs={false} sm={1} md={1} lg={1} align="center" className={classes.logoContainer}>
                      <img src={PersonalInfoIcon} alt="Personal Info Icon" className={classes.logo} />
                    </Grid>
                    <Grid item xs={11} sm={11} md={8} lg={8} align="left">
                      <div className={classes.headerContent}>
                        <div className={classes.headerText}>
                          <div className={classes.title}>
                            {isStudent(roles) || isAlumni(roles) ? (
                              <main>Personal Information</main>
                            ) : (
                              <main>
                                Personal Information for{' '}
                                {store.senior && store.senior.alumni_updated_first_name
                                  ? store.senior.alumni_updated_first_name
                                  : store.senior.first_name}{' '}
                                {store.senior && store.senior.alumni_updated_last_name
                                  ? store.senior.alumni_updated_last_name
                                  : store.senior.last_name}
                              </main>
                            )}
                          </div>
                        </div>
                      </div>
                      <div style={{ color: '#fff' }}>
                        {isStudent(roles) && <main>View your student information and update graduation date, email, GPA, and test scores.</main>}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3} align="left">
                      <div className={classes.plannerIcons}>
                        <Tooltip title="Click to return to the planner home page." placement="bottom">
                          <IconButton color="inherit" aria-label="return home" onClick={(e) => setPage('home')}>
                            <HomeIcon className={classes.homeIcon} style={{ color: '#fff' }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </Grid>
                  </Grid>
                </summary>
              </Grid>
            </Grid>
          </Box>
        </div>

        {!isStudent(roles) && !isAlumni(roles) && (
          <div className={classes.centerForm}>
            <Box
              sx={{
                width: '100%',
                maxWidth: {
                  xs: '380px',
                  sm: '540px',
                  md: '868px',
                  lg: '1280px',
                  xl: '1280px',
                },
              }}
            >
              <Grid container direction="row" className={classes.unprintedContent}>
                <Grid item xs={12}>
                  <div className={classes.breadcrumbs}>
                    <Breadcrumbs separator="›" aria-label="breadcrumbs" className={classes.alignCrumb}>
                      <span className={classes.breadCrumbLink} onClick={(e) => handleGotoAdminHomepage()}>
                        <HomeIcon style={{ fontSize: '1.30rem' }} />
                        <span style={{ margin: '1px 0 0 1px' }}>Home</span>
                      </span>
                      <span className={classes.breadCrumbLink} onClick={(event) => handleReturnToSeniorList()}>
                        {alumni ? 'Alumni' : 'High School Seniors'}
                      </span>
                      <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(e) => setPage('home')}>
                        {store.senior && store.senior.alumni_updated_first_name ? store.senior.alumni_updated_first_name : store.senior.first_name}{' '}
                        {store.senior && store.senior.alumni_updated_last_name ? store.senior.alumni_updated_last_name : store.senior.last_name}
                      </span>
                      <span className={classes.breadCrumbText} style={{ marginTop: '-1px' }}>
                        Planning Workbook
                      </span>
                    </Breadcrumbs>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </div>
        )}
      </div>

      <div className={classes.centerForm}>
        <Box
          sx={{
            width: '100%',
            maxWidth: {
              xs: '380px',
              sm: '540px',
              md: '868px',
              lg: '1320px',
              xl: '1320px',
            },
          }}
        >
          <Grid container spacing={3} direction="row" style={{ marginTop: '35px' }}>
            <Grid item xs={12} align="left" className={classes.printedContent}>
              <section className={classes.pageTitle}>
                <span className={classes.printHeaderText}>Personal Information</span>
              </section>
              <aside className={classes.printHeaderDesc}>
                {isAlumni(roles)
                  ? 'View your personal information and update address and phone numbers.'
                  : 'View your student information and update graduation date, email, GPA, and test scores.'}
              </aside>
            </Grid>
            <Grid item xs={12}>
              <div style={{ width: '95%', margin: '0 auto 0 auto' }}>
                <BasicInformation SeniorStore={store} AuthStore={auth} handleSaveReturn={handleAfterSaveReturn} />
              </div>
            </Grid>
          </Grid>
        </Box>
      </div>
    </summary>
  );
};

BasicInfo.propTypes = {
  alumni: PropTypes.bool,
  roles: PropTypes.array,
  store: PropTypes.object,
  auth: PropTypes.object,
  handleAfterSaveReturn: PropTypes.func,
  setPage: PropTypes.func,
  handleReturnToSeniorList: PropTypes.func,
  classes: PropTypes.object.isRequired,
  handleGotoAdminHomepage: PropTypes.func.isRequired,
};

export default BasicInfo;
